import {
  SET_LOGO_ELEMENT_WIDTH,
  SET_LOGO_ELEMENT_HEIGHT,
  SET_LOGO_ELEMENT_LINK_HOMEPAGE,
  SET_LOGO_ELEMENT_MARGIN,
  SET_LOGO_ELEMENT_PADDING,
} from './action-names';

export function setLogoElementWidth(data) {
  return {
    type: SET_LOGO_ELEMENT_WIDTH,
    ...data
  };
};

export function setLogoElementHeight(data) {
  return {
    type: SET_LOGO_ELEMENT_HEIGHT,
    ...data
  };
};

export function setLogoElementLinkHomepage(data) {
  return {
    type: SET_LOGO_ELEMENT_LINK_HOMEPAGE,
    ...data
  };
};

export function setLogoElementMargin(data) {
  return {
    type: SET_LOGO_ELEMENT_MARGIN,
    ...data
  };
};

export function setLogoElementPadding(data) {
  return {
    type: SET_LOGO_ELEMENT_PADDING,
    ...data
  };
};


// WEBPACK FOOTER //
// ./app/header-builder/actions/logo-element-actions.js